import { ContractService } from '@wlp/ui-bs-signup';
import { ModalPrivacyPolicyComponent } from './../../../modals/modal-privacy-policy/modal-privacy-policy.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { interval, of } from 'rxjs';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { DeviceService, SendCodeService } from '@wlp/ui-bs-device-validation';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { UiCSendCodeAccountActivationComponent } from '@wlp/ui-c-send-code-account-activation';
import { Subscription } from 'rxjs/internal/Subscription';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';

import {
  ModalAccountActivationComponent,
} from './../../../modals/modal-account-activation/modal-account-activation.component';


@Component({
  selector: 'ui-c-token-validation',
  templateUrl: './token-validation.page.html',
  styleUrls: ['./token-validation.page.scss'],
})
export class TokenValidationPage implements OnInit {

  wlName: string;
  company: any;
  celPhone: string;
  sub: Subscription;
  errorMessages: any;
  formSendCode: FormGroup;
  progressbarValue: number;
  accountMigration: any;
  @ViewChild('cd', { static: false }) public sendCode: UiCSendCodeAccountActivationComponent;
  phone = '';
  uuid = '';
  formDevice: FormGroup;
  policyUuid: string;
  policy: any;
  contract: any;

  data = {
    id: "",
    phone: ""
  };
  brand: any;
  navigationBackground: any;
  count: number = 0;
  paramTime: { time: any }

  constructor(
    private navCtrl: NavController,
    private sendCodeService: SendCodeService,
    private layoutConfigService: LayoutConfigService,
    /* private alertAccountService: AlertAccountService, */
    private alertAccountService: AlertController,
    private loadingService: LoadingService,
    public deviceService: DeviceService,
    private modalController: ModalController,
    private translate: UiBsTranslateService,
    private route: ActivatedRoute,
    private contractService: ContractService,
  ) {
    this.wlName = this.layoutConfigService.getConfig('wlTheme.wlName');
    this.company = this.layoutConfigService.getConfig('wlTheme.company');
    this.formSendCode = this.sendCodeService.getForm();
    this.errorMessages = this.sendCodeService.getErrorFormMessage();

    this.brand = this.layoutConfigService.getConfig('wlTheme.timeline.brand.logo');
    this.navigationBackground = this.layoutConfigService.getConfig('wlTheme.timeline.background.image');
    this.uuid = this.route.snapshot.paramMap.get('uuid');
  }

  ngOnInit() {
    this.loadingService.show();
    this.startProgress();
    this.sendCodeService.loadAccountMigration(this.uuid)
      .then(res => {
        res.subscribe(res => {
          let result: any = res;
          if (result.statusCode) {
            this.loadingService.hide();
            this.presentAlert(
              this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.FAILED_TITLE'),
              this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.FAILED'), []);
            return;
          } else {
            this.data.id = this.uuid;
            this.data.phone = res.phone;
            this.phone = res.phone;
            this.loadingService.hide();
            this.getPreAccount();
          }
          return;
        })
      })
      .catch(err => {
        this.presentAlert(
          this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.FAILED_TITLE'),
          this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.FAILED'), []);
        this.loadingService.hide();
        this.sendCodeService.getErrorSendCode(err);
      });
  }

  async getPreAccount() {
    await this.contractService.getTermsByPreAccount(this.uuid).then(res => {
      res.subscribe(res => {
        this.contract = res.contract;
        this.policyUuid = res.policy[0].uuid;
        //console.log(res);
        this.getTermsByUuid();
        return;
      })
    })
      .catch(err => {
        console.log(err);
      });

  }

  getTermsByUuid() {
    //console.log(this.policyUuid, "UUID");
    this.contractService.getTermByuuid(this.policyUuid).then(res => {
      res.subscribe(res => {
        this.policy = res
        //console.log(res, "Result");
        return;
      })
    })
      .catch(err => {
        console.log(err);

      });
  }

  async modalFlow(policy) {
    const modal = await this.modalController.create({
      component: ModalPrivacyPolicyComponent,
      cssClass: 'modal-flow-container-inner',
      componentProps: { wlName: this.wlName, company: this.company, policy, tokenValidation: true },
      backdropDismiss: false,
    });
    await modal.present();
    return await modal.onWillDismiss()
  };

  startProgress() {
    this.progressbarValue = 1;
    this.count = 0;
    const timer$ = interval(1000);
    this.sub = timer$.subscribe((sec) => {
      this.count = sec;
      this.paramTime = { time: 60 - this.count };
      this.progressbarValue = 1 - (sec * 20) / 1200;
      if (this.progressbarValue === 0) {
        this.sub.unsubscribe();
      }
    });
  }

  formSendCodeEmitter(event): void {
    this.loadingService.show();
    this.sendCodeService.sendCodeMigration(event, this.uuid).then(
      (res) => {
        if (res.valid) {
          this.modalCardNotification(
            'ACCOUNT_ACTIVATION.MESSAGES.SUCCESS_TITLE',
            'ACCOUNT_ACTIVATION.MESSAGES.SUCCESS',
            'ACCOUNT_ACTIVATION.ACCESS_ACCOUNT',
            true
          );
          this.loadingService.hide();
          //this.navCtrl.navigateRoot['/login'];
          return;
        } else {
          this.modalCardNotification(
            'ACCOUNT_ACTIVATION.MESSAGES.FAILED_ACTIVE_ACCOUNT_TITLE',
            'ACCOUNT_ACTIVATION.MESSAGES.FAILED_ACTIVE_ACCOUNT',
            'ACCOUNT_ACTIVATION.TRY_AGAIN',
            false
          );
          this.loadingService.hide();
        }
      },
      (err) => {
        this.loadingService.hide();
        this.sendCodeService.getErrorSendCode(err);
      }
    );
  }

  async modalCardNotification(title: string, message: string, button: string, isValid: boolean) {
    const modal = await this.modalController.create({
      component: ModalAccountActivationComponent,
      cssClass: 'modal-custom-class',
      componentProps: {
        title,
        message,
        button,
        isValid
      },
    });
    return await modal.present();
  }

  sendCodePhone() {
    if (this.phone) {
      this.deviceService.createDeviceMigration(this.data)
        .then(
          (res) => {
            this.presentAlert(
              this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.SEND_CODE_TITLE'),
              this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.SEND_CODE'),
              [this.translate.applyTranslate('ACCOUNT_ACTIVATION.MESSAGES.CONFIRM_BUTTON')])
            this.sendCodeService.setCelPhone(this.phone);
          },
          (err) => {
            this.deviceService.getErrorDevice(err);
          }
        );
    }
    else {

    }
  }

  subPhoneNumber() {
    if (this.phone == "") {
      return ""
    } else {
      return this.phone.slice(-4)
    }
  }

  presentAlert(header, message, buttons) {
    this.alertAccountService.create({
      header,
      message,
      buttons,
      backdropDismiss: false
    }).then(res => {
      res.present();
    })
  }

}
